import { TableCellProps } from '@mui/material'
import { COLORS } from 'styles/colors'
import { TypographySecondary } from 'ui/typography/TypographySecondary'
export const TABLE_HEAD = {
	rowKey: 'tableMilkYieldWidgetHead',
	rowBorderBottom: COLORS.secondaryFontOpacity,
	rowHeight: '20px',
	cellItems: [
		{
			padding: '0px 0px 4px 0px',
			width: '50%',
			children: <TypographySecondary>Молоко</TypographySecondary>,
		},
		{
			padding: '0px 0px 4px 0px',
			width: '50%',
			children: <TypographySecondary>Литры</TypographySecondary>,
		},
		{
			padding: '0px 0px 4px 0px',
			width: '10%',
			children: <TypographySecondary>%</TypographySecondary>,
			align: 'right' as TableCellProps['align'],
		},
	],
}
